/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';
import { Container as BaseContainer } from '@components/common/primitives';

// Styles for box from RuneScape. Need to do something with it.
export const FlexContainer = styled(BaseContainer)`
  display: flex;
  height: 100%;
  font-family: ${themeGet('fonts.main')};
`;
